<template>
  <div class="list-items">
    <div class="row">
      <div class="col-sm-6 col-md-4 col-lg-4">
        <div class="row">
          <div class="item">
            <span class="rounder bg-red">
              <ul>
                <li><b>20%</b></li>
              </ul>
            </span>
            <div class="item-body">
              <div class="item-left">
                <img
                  src="../../assets/images/tpbank.jpg"
                  alt=""
                  width="100%">
              </div>
              <div class="item-right">
                <ul>
                  <li class="name-item">Lorem ipsum dolor sit amet, consectetur</li>
                  <li><rating/></li>
                  <li class="price">
                    <b class="sale-price">2.000.000 đ</b> <span class="price">2.500.000 đ</span>
                  </li>
                  <li class="sale_up_to">(tiết kiệm 500000 đ)</li>
                  <li class="item_nv">500 nhận xét</li>
                </ul>
                <div class="detail-item ">
                  <a
                    href="#">Xem chi tiết<i class="fa fa-chevron-right"/></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import rating from '../include/rating'

  export default {
    name: 'Items',
    components: {
      rating: rating
    },
  }

</script>

<style scoped>
  .name-item{
    font-size: 1rem;
    text-decoration: none;
    color: #000;
    cursor: pointer;
    padding-bottom: 5px;
  }
  .price .sale-price{
    font-size: 1rem;
    color: #FF595A;
  }
  .price .price{
    font-size: 0.8rem;
    margin-left: 3px;
  }

  .sale_up_to{
    color: #418AEB;
  }
  .item-right ul {
    border-bottom: 1px solid #eee;
  }
  .detail-item {
    margin-left: 10px;
    margin-top: 3px;
  }

  .rounder {
    position: absolute;
    z-index: 2;
    height: 50px;
    width: 50px;
    border-radius: 50%;
  }

  .rounder ul {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .fa-chevron-right {
    position: absolute;
    right: 10px;
    font-size: 11px;
    bottom: 13px;
    color: #e1e4e9;
  }

</style>



// WEBPACK FOOTER //
// src/components/item/Items.vue